<div *ngIf='componentReady' class='EditBlockedDate'>
  <div class='EditBlockedDate__header d-flex flex-column flex-sm-row justify-content-between'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/campaigns', 'block_dates']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a
          [routerLink]="['/campaigns', 'block_dates']"
          class='Breadcrumbs-item first'
        >Blocked Dates</a
        >
        <ng-container *ngIf='state === "edit" && blockDate; else newDate'>
          <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
          <span class='Breadcrumbs-item'>{{ blockDate.block_date | timezone: 'MM/DD/YYYY' }}</span>
        </ng-container>
        <ng-template #newDate>
          <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
          <span class='Breadcrumbs-item'>New Blocked Date</span>
        </ng-template>
      </div>
    </div>
    <app-button *ngIf='state === "new"' [Click]='addButtonProperties.onClick' [color]='addButtonProperties.color'
                [size]='addButtonProperties.size'
                [text]='addButtonProperties.text'></app-button>
  </div>
  <div class='EditBlockedDate__body mt-5'>
    <ng-container *ngIf='state === "new"'>
      <div [formGroup]='formGroup' class='EditBlockedDate__body__form'>
        <mat-radio-group
          (change)='changeDateType($event)'
          aria-label='Select an frequency'
          class='EditBlockedDate__body__form__radio'
          formControlName='date_type'>
          <mat-radio-button [value]='blockedDateTypes.single'
          >Exact date
          </mat-radio-button
          >
          <mat-radio-button [value]='blockedDateTypes.range' class='ms-3'
          >Date range
          </mat-radio-button
          >
        </mat-radio-group>
        <div class='EditBlockedDate__body__form__date mt-5'>
          <div class='row'>
            <div class='col col-12 col-sm-5 align-content-center'>
              <div class='alert alert-warning'>
                <p class='mb-0'>Please note, you can block today's date before 9:30 AM (UTC) of the same day</p>
              </div>
            </div>
          </div>
          <ng-container *ngIf='date_type.value === blockedDateTypes.single; else multiRange'>
            <div class='row'>
              <div class='col col-12 col-sm-2 align-content-center'>
                <mat-label>Select date</mat-label>
              </div>
              <div class='col col-12 col-sm-3 align-content-center'>
                <app-text-field [datePickerStartDate]='getStartDate()' datePickerType='calendar'
                                formControlName='blocked_date'
                                type='date'></app-text-field>
              </div>

            </div>
          </ng-container>
          <ng-template #multiRange>
            <div class='row'>
              <div class='col col-12 col-sm-2 align-content-center'>
                <mat-label>Select start date</mat-label>
              </div>
              <div class='col col-12 col-sm-3'>
                <app-text-field [datePickerStartDate]='getStartDate()' datePickerType='calendar'
                                formControlName='blocked_date'
                                type='date'></app-text-field>
              </div>
            </div>
            <div class='row mt-5'>
              <div class='col col-12 col-sm-2 align-content-center'>
                <mat-label>Select end date</mat-label>
              </div>
              <div class='col col-12 col-sm-3'>
                <app-text-field [datePickerStartDate]='getEndDate()' datePickerType='calendar'
                                formControlName='blocked_date_end'
                                type='date'></app-text-field>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <div *ngIf='sessionData.user_type === "master"' class='EditBlockedDate__body__rules mt-5'>
      <h1>Rules</h1>
      <hr>
      <app-blocked-date-rules (changed)='addRule($event)' (deleted)='deleteRule($event)' [canAdd]='true'
                              [canDelete]='true' [createRule]='state === "edit"'
                              [dateId]='id'
                              [rules]='dateRules'></app-blocked-date-rules>
    </div>
  </div>
</div>